export enum SequenceStatus {
  //ml st
  WaitingForMlStitching,
  MlStitchingInProgress,
  MlStitchingCompleted,
  MlStitchingFailed,

  //manual st
  WaitingForManualStitching,
  ManualStitchingInProgress,
  ManualStitchingCompleted,
  ManualStitchingNotNeeded,

  //review
  WaitingForMlReview,
  MlReviewInProgress,
  MlReviewCompleted,
  MlReviewFailed
}
